import { motion, AnimatePresence } from "framer-motion";

interface LoadingSplashProps {
  show: boolean;
}

export function LoadingSplash({ show }: LoadingSplashProps) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background"
        >
          <motion.svg
            width="48"
            height="48"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <path
              d="M32 4L8 16V34C8 48 18 58 32 62C46 58 56 48 56 34V16L32 4Z"
              stroke="hsl(var(--primary))"
              strokeWidth="2.5"
              opacity="0.9"
            />
            <line
              x1="32" y1="32" x2="48" y2="18"
              stroke="hsl(var(--primary))"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <circle cx="32" cy="32" r="3" fill="hsl(var(--primary))" opacity="0.9" />
          </motion.svg>
          <motion.span
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.4 }}
            className="mt-4 font-display text-lg font-bold text-foreground tracking-tight"
          >
            BotSweep<span className="text-primary">.</span>
          </motion.span>
          <motion.div
            className="mt-6 w-10 h-0.5 rounded-full bg-primary/30 overflow-hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            <motion.div
              className="h-full bg-primary rounded-full"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
